module.exports = __webpack_public_path__ + "img/1_002.9d698b1c.jpg";